function updateBannerImageInputVisibility() {
  const checkBox = document.querySelector('.js-event-bundle-ad');
  const imageArea = document.querySelector('.js-event-bundle-banner-image-area');
  if (checkBox == null || imageArea == null) return;

  if (checkBox.checked) {
    imageArea.style.display = 'block';
  } else {
    imageArea.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const checkBox = document.querySelector('.js-event-bundle-ad');
  if (checkBox == null) return;

  checkBox.addEventListener('change', updateBannerImageInputVisibility);
  updateBannerImageInputVisibility();
});
